import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css'; // [bootstrap]
import 'bootstrap'; // [bootstrap]
import { BootstrapIconsPlugin } from 'bootstrap-icons-vue';
import { createNaverMap } from 'vue3-naver-maps';
import LoadScript, { loadScript } from 'vue-plugin-load-script';
import { makeNaverMapsLoader } from '@/utils/naverMaps';
import '@/assets/css/reset.scss';
import '@/assets/css/common.scss';
// import axios from 'axios';
import seon from './seon';
import money from 'v-money3';
import { formatArea, formatNumber, formatMoneyMuch, normalizeAddr, formatLinkAddr, formatRatio } from '@/utils/format';

const app = createApp(App);

// egpy3fy0c0
// salgni0xx3
// app.config.globalProperties.$axios = axios;
app.use(createNaverMap, {
	clientId: process.env.VUE_APP_NAVER_API_ID, // Required
	enableAiMaps: false, // Use ncpKeyId (new NCP Maps Application format)
	// subModules: ['geocoder', 'panorama'], // Optional, "panorama" | "geocoder" | "drawing" | "visualization"
});

// DEPRECATED (F-2.2): 더 이상 .vue 에서 직접 참조하지 않는다. 신규 코드는 $formatNumber 사용.
// 남겨두는 이유는 외부 확장/플러그인 호환성뿐이며, 다음 정리 단계에서 제거 예정.
// 버그: null/빈 값에 대해 숫자 0 을 반환한다 ($formatNumber 는 빈 문자열 반환).
app.config.globalProperties.$filters = {
	money(value) {
		if (value) {
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		} else {
			return 0;
		}
	},
};

// F-2.2: 숫자/면적 포맷 유틸.
//   - $formatArea / $formatNumber : 공용 포맷 (기존 $filters.money 대체).
//   - $formatMoneyMuch             : spec 의 "N억 M만원" 포맷. seon.js 의
//     $formatMoney(_, MUCH) 와 호환되지 않으므로 신규 지점에서만 사용.
// F-2.1: 주소 정규화 (서울특별시→서울, 번지 제거). Legacy row 방어선.
app.config.globalProperties.$formatArea = formatArea;
app.config.globalProperties.$formatNumber = formatNumber;
app.config.globalProperties.$formatMoneyMuch = formatMoneyMuch;
app.config.globalProperties.$normalizeAddr = normalizeAddr;
app.config.globalProperties.$formatLinkAddr = formatLinkAddr;
// DD (2026-10-17): 건폐율·용적률. 값이 없거나 0 이면 '-'.
app.config.globalProperties.$formatRatio = formatRatio;

// console.log(seon);
app.use(money);
app.use(seon);
app.use(store);
app.use(router);
app.use(LoadScript);
app.use(BootstrapIconsPlugin);

// 거리뷰(로드맵) race 수정: maps.js + 요청 서브모듈(panorama)이 둘 다 준비된 뒤에만
// resolve 하는 중앙 로더. 기존 $loadScript(...&submodules=panorama) 직접 호출을
// $loadNaverMaps('panorama') 로 대체한다. (frontend/src/utils/naverMaps.mjs)
app.config.globalProperties.$loadNaverMaps = makeNaverMapsLoader({
	loadScript,
	getMaps: () => (typeof window !== 'undefined' && window.naver ? window.naver.maps : undefined),
	clientId: process.env.VUE_APP_NAVER_API_ID,
});

app.mount('#app');
